import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Presets from "../presets/Presets";
import { BlueButton } from "../../molecules/BlueButton";
import { ColorlibStepIcon } from "./PcbStepper";
import { TranparentButton } from "../../molecules/LightButton";
import Design from "../design/Design";
import Overview from "../overview/Overview";
import { CartContext } from "../../contex/CartProvider";
import BuyNow from "../buynow/BuyNow";
import CustomMobileStepper from "./MobileStepper";

const CustomStepper = () => {
  const { cart } = React.useContext(CartContext);
  const steps = ["presets", "design", "overview", "buy now"];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className="mt-6 md:mt-12">
      <div className=" md:hidden">
        <CustomMobileStepper />
      </div>
      <div className="hidden md:block">
        <Box>
          <Box sx={{ width: "70%", margin: "auto" }}>
            <Stepper
              activeStep={activeStep}
              // orientation={"vertical"}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                if (isStepOptional(index)) {
                  labelProps.optional = (
                    <Typography variant="caption"></Typography>
                  );
                }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel
                      {...labelProps}
                      StepIconComponent={ColorlibStepIcon}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>

          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* Render items */}
              {activeStep === 0 && <Presets />}
              {activeStep === 1 && <Design />}
              {activeStep === 2 && <Overview />}
              {activeStep === 3 && <BuyNow />}
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <BlueButton
                  color="inherit"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </BlueButton>
                <Box sx={{ flex: "1 1 auto" }} />
                {/* {isStepOptional(activeStep) && ( */}
                <TranparentButton
                  color="inherit"
                  // onClick={handleSkip}
                  sx={{ mr: 1 }}
                >
                  Live Chat
                </TranparentButton>
                {/* )} */}

                <BlueButton
                  onClick={handleNext}
                  disabled={activeStep === 1 && cart.length === 0}
                >
                  {activeStep === steps.length - 1 ? "Finish" : "Next"}
                </BlueButton>
              </Box>
            </React.Fragment>
          )}
        </Box>
      </div>
    </div>
  );
};

export default CustomStepper;
